import { shadowWidgetCss } from "./widget-css"

export const tailwindStyles = shadowWidgetCss
